import styled from "styled-components/macro";
import { themeVariables } from "../../../../themeVariables";

export const StyledContainer = styled.div`
  width: calc(100% - 40px);
  margin: 16px 0px;
  transition: margin 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  gap: 8px;

  &.expanded {
    margin: 16px 0px;
  }

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  .extra-instructions-toggle {
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    user-select: none;

    .toggle-chevron {
      width: 12px;
      height: 12px;
      transition: transform 0.2s ease-in-out;
      flex-shrink: 0;

      path {
        fill: ${themeVariables.grey2};
      }

      &.collapsed {
        transform: rotate(-90deg);
      }
    }
  }
`;
